export function getResizedImageAsBlob(imageSource, mime = 'image/jpeg', maxSize = 1920, quality = 0.7): Promise<Blob> {
  return new Promise(resolve => {
    const img = new Image();
    img.src = imageSource as string;
    img.onload = () => {
      let width = img.width;
      let height = img.height;
      const maxDimension = Math.max(width, height);
      if (maxDimension > maxSize) {
        const scale = maxSize / maxDimension;
        width = scale * img.width;
        height = scale * img.height;
      }
      const elem = document.createElement('canvas');
      elem.width = width;
      elem.height = height;
      const ctx = elem.getContext('2d');
      if (!ctx) {
        return;
      }
      ctx.drawImage(img, 0, 0, width, height);
      const canvasData = ctx.canvas.toDataURL(mime, quality);
      /**
       * Transform to blob
       */
      const blobBin = atob(canvasData.split(',')[1]);
      const blobArr: number[] = [];
      for (let i = 0; i < blobBin.length; i++) {
        blobArr.push(blobBin.charCodeAt(i));
      }
      resolve(new Blob([new Uint8Array(blobArr)], { type: mime }));
    };
  });
}
